import { Component, OnInit } from '@angular/core';
import { ArkUnitOfWork } from 'app/core/core.module';
import { AuctionPaddle } from 'app/core/model/auction-paddle';
import { AuctionPaddleUser } from 'app/core/model/auction-paddle-user';
import { Person } from 'app/core/model/person';
import _ from 'lodash';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-paddle-dialog',
    templateUrl: './paddle-dialog.component.html',
    styleUrls: ['./paddle-dialog.component.scss'],
})
export class PaddleDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    people: Person[];
    paddles: AuctionPaddle[];
    paddleUser: AuctionPaddleUser;
    selectedPaddle: any;

    constructor(public modalRef: BsModalRef, private uow: ArkUnitOfWork) {}

    async ngOnInit() {
        console.log(this.selectedPaddle);
        if (!this.paddleUser) {
            this.paddleUser = this.uow.auctionPaddleUsers.createEntity({
                created: new Date(),
                auctionPaddleId: this.selectedPaddle ? this.selectedPaddle.paddleNumber : null,
                name: '',
                email: '',
                phone: '',
                address: '',
                city: '',
                state: '',
                zip: '',
            }) as AuctionPaddleUser;
        }
    }

    personChanged(e) {
        if (!e.value) {
            this.paddleUser.personId = null;
            this.paddleUser.name = null;
            this.paddleUser.email = null;
            this.paddleUser.phone = null;
            this.paddleUser.address = null;
            this.paddleUser.city = null;
            this.paddleUser.state = null;
            this.paddleUser.zip = null;
        } else {
            const person = _.find(this.people, { id: e.value });
            this.paddleUser.name = person.displayNameLastFirst;
            this.paddleUser.email = person.email;
            this.paddleUser.phone = person.cellPhone;
            this.paddleUser.address = person.family.address1;
            this.paddleUser.city = person.city;
            this.paddleUser.state = person.state;
            this.paddleUser.zip = person.zip;
        }
    }

    async save() {
        await this.uow.commit();
        this.result.next({ success: true });
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }
}
